
export default {
  init(){
    let documentElement = document.documentElement
    documentElement.setAttribute('data-useragent', navigator.userAgent)
    documentElement.setAttribute('data-platform', navigator.platform )

  }
}


// WEBPACK FOOTER //
// ./src/helpers/modules/platformHandler.js